import { createFileRoute } from "@tanstack/react-router";
import { RunPage } from "../features/runs/run-page";

export const Route = createFileRoute("/_app/w/$workspace/p/$project/runs/$run")({
  component: RunPage,
});
